import React, { useEffect, useState } from "react";
import useFushiChat from "./useFushiChat";
import FushiPanel from "./FushiPanel";
import FushiMascot from "./FushiMascot";
import "./fushi.css";

// Floating launcher + chat window. Mounted once (on the HomePage) in App.js.
// The chat hook lives here so the conversation survives closing/reopening the panel.
const FushiWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const chat = useFushiChat();

  // Escape closes the panel.
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <FushiPanel
          messages={chat.messages}
          isLoading={chat.isLoading}
          onSend={chat.send}
          onNewChat={chat.newChat}
          onClose={() => setIsOpen(false)}
        />
      )}

      {/* Launcher hides while the panel is open — the header ✕ is the single close control. */}
      {!isOpen && (
        <button
          type="button"
          className="fushi-launcher"
          data-label="Chat with Fushi"
          aria-label="Chat with Fushi"
          aria-expanded={false}
          onClick={() => setIsOpen(true)}
        >
          <span className="fushi-launcher-icon">
            <FushiMascot
              size={54}
              outlineColor="#17bd3b"
              faceColor="#ffffff"
              featureColor="#1c1c1c"
              shineColor="#ffffff"
            />
          </span>
        </button>
      )}
    </>
  );
};

export default FushiWidget;
